export default class Tracking {
  /**
   * wrapper for thor.pushEvent calls
   * @param {object} vars - The tracking variables to send
   */

  static PushEvent(eventName, vars) {
    if (window !== undefined) {
      const savedThor = window.thor ? window.thor : null
      const doIt = () => {
        if (savedThor !== null) {
          savedThor.pushEvent(eventName, vars)
        }
      }

      const fastRequest = eventName === 'view'
      if (fastRequest) {
        // for requests tested to be fast, send them immediatelly
        doIt()
      } else if ('requestIdleCallback' in window) {
        // in modern browsers, wait until the browser is not occupied
        // by more important stuff, like animations or user input
        // but send the push no later than 250ms
        // (actually it will be sent later, but it's good enough)
        window.requestIdleCallback(doIt, { timeout: 250 })
      } else {
        // in older browsers just delay the execution of tracking
        setTimeout(doIt)
      }
    }
  }

  static PushView(state) {
    this.PushEvent('view', {
      site: 'SL',
      language: 'fr',
      url_path: window.location.href,
      environment: global.environment,
      referrer: window.document.referrer,
      ...state,
    })
  }

  static PushInteraction = state => this.PushEvent('interaction', state)
}
